import { api, authHeader } from "../configs/axiosConfigs";

const PaymentsApiService = {

// متد های مربوط به سیستم انتخاب نوع پرداخت



  // دریافت لیست پکیج‌های فعال
  getPaymentMethodList: async () => {
    const response = await api.request({
      url: "/SLN/Customer/ProjectPayment/GetPaymentMethodList",
      method: "GET",
      params: { includeEquipments: true }, // درخواست دریافت تجهیزات
    });
    return response.data;
  },

  // دریافت جزئیات پکیج
  getPaymentDetails: async (id) => {
    const response = await api.request({
      url: `/api/Payments/GetPaymentDetails/${id}`,
      method: "GET",
    });
    return response.data;
  },

  // دریافت پکیج‌های پیمانکار
  getContractorPayments: async (contractorId) => {
    const response = await api.request({
      url: `/api/Payments/GetContractorPayments/${contractorId}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  // جستجوی پکیج‌ها
  searchPayments: async (params) => {
    const response = await api.request({
      url: "/api/Payments/SearchPayments",
      method: "GET",
      params: { ...params, includeEquipments: true }, // درخواست دریافت تجهیزات
    });
    return response.data;
  },

  // مقایسه پکیج‌ها
  comparePayments: async (paymentIds) => {
    const response = await api.request({
      url: "/api/Payments/ComparePayments",
      method: "POST",
      headers: authHeader(),
      data: { paymentIds },
    });
    return response.data;
  },

  // دریافت پکیج‌های قابل انتخاب برای یک درخواست
  getPaymentsForRequest: async (requestId) => {
    console.log("=== PaymentsApiService.getPaymentsForRequest ===");
    console.log("requestId:", requestId);
    console.log("URL:", `/api/Payments/GetPaymentsForRequest/${requestId}`);

    const response = await api.request({
      url: `/api/Payments/GetPaymentsForRequest/${requestId}`,
      method: "GET",
      headers: authHeader(),
      params: { includeEquipments: true }, // درخواست دریافت تجهیزات
    });

    console.log("Response:", response);
    return response.data;
  },

  // ثبت انتخاب پکیج برای درخواست و ایجاد قرارداد
  selectPaymentForRequest: async (requestId, paymentId, contractorId) => {
    const response = await api.request({
      url: "/api/Payments/SelectPaymentForRequest",
      method: "POST",
      headers: authHeader(),
      data: {
        requestId,
        paymentId,
        contractorId,
      },
    });
    return response.data;
  },

 //پایان  متد های مربوط به سیستم انتخاب نوع پرداخت 


  getMyPayments: async () => {
    const response = await api.request({
      url: `/api/Payments/GetMyPayments`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getPaymentDetails: async (paymentId) => {
    const response = await api.request({
      url: `/api/Payments/GetPaymentDetails?id=${paymentId}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  initiatePayment: async (paymentData) => {
    const response = await api.request({
      url: `/api/Payments/InitiatePayment`,
      method: "POST",
      data: paymentData,
      headers: authHeader(),
    });
    return response.data;
  },

  verifyPayment: async (authority, status) => {
    const response = await api.request({
      url: `/api/Payments/VerifyPayment?authority=${authority}&status=${status}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getInvoicePayments: async (invoiceId) => {
    const response = await api.request({
      url: `/api/Payments/GetInvoicePayments?invoiceId=${invoiceId}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },
};

export default PaymentsApiService;
